<template>
  <div class="store-table__layout">
    <div class="store-table">
      <div class="store-table__head">
        <div class="store-table__image" v-if="!hideImage"></div>
        <div class="store-table__name" v-if="!hideName">
          {{ translations.productName }}
        </div>
        <div class="store-table__sku" v-if="!hideSKU">
          {{ translations.productSKU }}
        </div>
        <div
          class="store-table__key"
          v-for="key in displayedProductsAttributes"
          :key="key"
        >
          {{ getAttributeTaxonomyLabel(key) }}
        </div>
        <div class="store-table__price">{{ translations.productPrice }}</div>
        <div class="store-table__other" v-if="showOtherInfo">
          {{ translations.other }}
        </div>
        <div class="store-table__cart">{{ translations.addToCart }}</div>
      </div>
      <!-- <thead> -->
      <!-- <tr>
        <th v-if="!hideImage"></th>
        <th v-if="!hideName">{{ translations.productName }}</th>
        <th v-if="!hideSKU">{{ translations.productSKU }}</th>
        <th v-for="key in displayedProductsAttributes" :key="key">
          {{ getAttributeTaxonomyLabel(key) }}
        </th>
        <th>{{ translations.productPrice }}</th>
        <th v-if="showOtherInfo">{{ translations.other }}</th>
        <th>{{ translations.addToCart }}</th>
      </tr>
    </thead> -->
      <div
        class="store-table__content"
        v-if="displayedProducts.length > 0 && !$store.state.view.isLoading"
      >
        <template v-for="product in displayedProducts">
          <VariationRow
            :product="product"
            :displayedAttributeTaxonomies="displayedProductsAttributes"
            v-if="product.is_variable"
            :key="`${prefix}${product.id}`"
            :showOtherInfo="showOtherInfo"
            :hideImage="hideImage"
            :hideName="hideName"
            :hideSKU="hideSKU"
          />
          <SimpleRow
            :product="product"
            :displayedAttributeTaxonomies="displayedProductsAttributes"
            v-if="!product.is_variable"
            :key="`${prefix}${product.id}`"
            :showOtherInfo="showOtherInfo"
            :hideImage="hideImage"
            :hideName="hideName"
            :hideSKU="hideSKU"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VariationRow from './VariationRow.vue';
import SimpleRow from './SimpleRow.vue';

export default {
  name: 'ProductTable',
  components: {
    VariationRow,
    SimpleRow,
  },
  props: {
    prefix: {
      type: String,
      default() {
        return '';
      },
    },
    displayedProducts: {
      type: Array,
      default() {
        return [];
      },
    },
    hideImage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideSKU: {
      type: Boolean,
      default() {
        return ws_vue_store.archive_product_sku === '0';
      },
    },
  },
  data() {
    return {
      translations: {
        productName: ws_vue_store.translations.product_name,
        productSKU: ws_vue_store.translations.product_SKU,
        productPrice: ws_vue_store.translations.product_price,
        other: ws_vue_store.translations.other,
        addToCart: ws_vue_store.translations.add_to_cart_heading,
        noProductsMatch: ws_vue_store.translations.no_products_match
      },
      allowedAttributes: this.$store.getters.getAllowedAttributes

    };
  }, // data
  created() {}, // created
  computed: {
    displayedProductsAttributes() {
      let self = this;
      if (this.displayedProducts.length === 0 || this.displayedProducts == undefined) {
        return [];
      }

      return [
        ...new Set(
          this.displayedProducts
            .map(product => {
              return product.attributes.map(attr => {
                if(this.allowedAttributes.includes(attr.key)){
                  return attr.key;
                }
              })
              .filter(function( element ) {
                 return element !== undefined;
              })
              .sort(function(a, b){
                return self.allowedAttributes.indexOf(a) - self.allowedAttributes.indexOf(b);
              });
            })
            .flat()
        )
      ]

    },
    showOtherInfo() {
      if (this.displayedProducts.length === 0) {
        return false;
      }

      return this.displayedProducts.some(product => 
        !product.is_variable
          ? product.excerpt.length
          : product.excerpt.length
      );
    },
  }, // computed
  watch: {}, // watch
  methods: {
    getAttributeTaxonomyLabel(taxonomyName) {
      const taxonomy = this.$store.getters.getAttributeTaxonomy(taxonomyName);
      if (taxonomy) {
        return taxonomy.label;
      }
      return '';
    },
  }, // methods
};
</script>

<style scoped lang="scss">
.store-table {
  &__head {
    display: grid;
    // grid-template-columns: 6rem 20rem 0.2fr 0.1fr 0.1fr 0.1fr 0.1fr 0.4fr 12rem;
    // gap: 2rem;

    div {
      //word-break: break-all;
    }
  }
}
</style>
